import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * 工單彙總轉倉候選（Draft：`mom.work_order.stock_transfer.candidates`）。
 * GET `/mom/work-order/stock-transfer/candidates?work_warehouse_id=`
 *
 * `workWarehouseId`＝原料轉入**目標工作倉**（非成品 `targetWarehouseId`）。
 * `data`：`workWarehouse`、`materials[]`
 * （`requiredQty`／`onHandQty`／`shortageQty`、`workOrders[]`、`transferableInventoryStocks[]`）。
 * `onHandQty`＝目標工作倉實體可用；`transferableInventoryStocks`＝他倉（`stockId`），不含 PENDING。
 * 僅準備轉倉；不鎖庫、不建單。
 *
 * @param {object} params
 * @param {string} params.workWarehouseId
 * @param {object} [params.filters]
 * @param {array} [params.sort]
 */
export async function fetchWorkOrderStockTransferCandidates({
  workWarehouseId,
  ...listQuery
} = {}) {
  const { data: raw } = await request.get(
    '/mom/work-order/stock-transfer/candidates',
    {
      params: listQueryToApiParams({
        sort: listQuery.sort ?? [],
        filters: {
          ...(listQuery.filters ?? {}),
          ...(workWarehouseId ? { workWarehouseId } : {}),
        },
      }),
    },
  );
  return parseVer4DetailResponse(raw);
}
